import React, { useMemo } from 'react';
import TimeGrid from './TimeGrid';
import { startOfWeek, addDays } from './calendarItems';

export default function WeekView({ items, cursor, onSelect }) {
  const days = useMemo(() => {
    const s = startOfWeek(cursor);
    return Array.from({ length: 7 }, (_, i) => addDays(s, i));
  }, [cursor]);

  return (
    <div className="overflow-x-auto" data-testid="calendar-week-view">
      <div className="min-w-[720px]">
        <TimeGrid days={days} items={items} onSelect={onSelect} testId="calendar-week-grid" />
      </div>
    </div>
  );
}
